// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jCVB","colBig":"styles_colBig__1mMA-","colSmall":"styles_colSmall__3nZZ3","shopifyNameWrapper":"styles_shopifyNameWrapper__1UBSr"};